export default "__VITE_ASSET__55f4c5d7__"